/**
 * Tasarım değerleri: `docs/ekranlar/README.md` "Tasarım değerleri" tablosu (CLAUDE.md "Tasarım").
 * Bileşenlerde ham renk kodu yazılmaz; renkler buradan ya da CSS değişkenlerinden gelir.
 * `tokens.test.ts` bu değerlerin tabloyla aynı olduğunu doğrular.
 */
export const TOKENS = {
  'navy-900': '#0A1F44',
  'navy-800': '#0B2A55',
  'primary-600': '#0B6CE6',
  // Sol menüde etkin öğe (personel-sertifikalar.jpeg; M6f G1-02)
  'nav-active': '#245597',
  'page-bg': '#F1F7FC',
  surface: '#FFFFFF',
  'text-secondary': '#3A5078',
  // Kart, tablo, giriş ve ayırıcı kenarlığı: text-secondary %14'ün beyaz üzerindeki karşılığı (M6f G1-01)
  border: '#E3E7EC',
  // Tablo başlık bandı (personel-sertifikalar.jpeg "Certificate Matrix")
  'table-head-bg': '#F2F5FA',
  'success-bg': '#D5F5E6',
  'success-fg': '#14915F',
  'warning-bg': '#FCEBB6',
  'warning-fg': '#A86B00',
  // Grafik dilimi, nokta ve ikon diski; metinde kullanılmaz (personel-sertifikalar.jpeg "Expiring")
  'warning-500': '#FCBD40',
  'danger-bg': '#FCD5D5',
  'danger-fg': '#D12F2F',
  'info-bg': '#D3E5FC',
  'info-fg': '#1D5FD0',
  // İş türleri (personel-mlc-calisma-dinlenme.jpeg); nöbet `primary-600`, manevra `danger-fg`
  'activity-rest': '#98A9C3',
  'activity-port': '#9964E8',
  'activity-anchor': '#FCA325',
  // Önizleyici (gemi-ism-formlari.jpeg; M8a3): koyu araç çubuğu ve sayfanın çevresi
  'viewer-toolbar': '#334558',
  'viewer-canvas': '#F1F2F4',
  // Sertifika kategori rozetleri (gemi-sertifika-takibi.jpeg "Type" sütunu; M7d, plan "Vessel
  // Certificates kategori rozetleri"): zemin ve yazı; yazı rozette WCAG AA (≥ 4,5:1)
  'cert-solas-bg': '#D6ECFE',
  'cert-solas-fg': '#1A4D99',
  'cert-marpol-bg': '#CDF7E5',
  'cert-marpol-fg': '#146442',
  'cert-mlc-bg': '#E0B9FF',
  'cert-mlc-fg': '#471192',
  'cert-ism-bg': '#A8E8F3',
  'cert-ism-fg': '#06476C',
  'cert-isps-bg': '#FFC6B2',
  'cert-isps-fg': '#9C2E1B',
  'cert-env-bg': '#BCF6DD',
  'cert-env-fg': '#17684A',
  'cert-flag-bg': '#CDE8FF',
  'cert-flag-fg': '#26559C',
  'cert-other-bg': '#DFE8F1',
  'cert-other-fg': '#4A5D72',
  // Risk matrisi hücreleri ve lejant (gemi-risk-degerlendirme.jpeg; ADR 0050 §2): yazı navy-900
  'risk-very-low': '#3CC37A',
  'risk-low': '#9FE08C',
  'risk-medium': '#FBE38A',
  'risk-high': '#F9B16E',
  'risk-very-high': '#F26B6B',
  // Ortağın 4 bandının en üstü (ADR 0085 §2): Very High ile aynı kırmızı
  'risk-critical': '#F26B6B',
} as const;

export type TokenName = keyof typeof TOKENS;

/** Düzen ölçüleri (README "Düzen ölçüleri"). */
export const LAYOUT = {
  /**
   * Sol menü: referansta 224 px = 1920 CSS px'te 280 (ADR 0020); ekranla daralır, en az 224.
   */
  navbarWidth: 'clamp(224px, 14.6vw, 280px)',
  navbarWidthCompact: 72,
  headerHeight: 68,
  radiusCard: 8,
  radiusButton: 6,
} as const;

/**
 * Katman sırası (z-index). `modal` ve `popover` Mantine'in varsayılanlarıdır (pencere; açılır liste
 * ve ipucu). Kabuğun "Discard unsaved changes?" onayı her pencerenin ve açılır listenin üstündedir:
 * pencereyle aynı katmandayken DOM'da sonra açılan düzenleme penceresinin altında kalıyordu (M6f
 * G1d-2). Kilit ekranı (ADR 0034) her şeyin üstünde.
 */
export const LAYERS = {
  modal: 200,
  popover: 300,
  confirm: 400,
  lock: 1000,
} as const;

/** Token'ların CSS değişkeni olarak adı: `--felix-<ad>`. */
export function tokenVar(name: TokenName): string {
  return `var(--felix-${name})`;
}
